import Vue from 'vue';

// When the request succeeds
const success = (response, context, page) => {
  toastr.success(context.$t('booking.index.sync_bookings'));
  if(page == 'calendar') {
    context.get_rentals();
  }else if(page == 'bookings') {
    context.getBooking();
  }
};

// When the request fails
const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, page) => {
  return Vue.$http.get('/refresh-bookings')
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context, page);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/refreshBookings.js